import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as form } from 'redux-form';

import account from './account/accountReducer';
import api from './api/apiRootReducer'; // TODO move this module up one level
import { reducer as appConfig } from './appConfig';
import basket from './basket/reducer';
import cart from './cart/reducer';
import { reducer as cartStack } from './cartStack';
import deleteProjectDialog from './deleteProjectDialog/reducer';
import dialogs from './dialogs/reducer';
import errors from './error/errorReducer';
import gtm from './gtm/reducer';
import internalOnly from './internalOnly/reducer';
import maintenanceMode from './maintenanceMode/reducer';
import manageRedirect from './manageRedirect/manageRedirectReducer';
import marketplace from './marketplace/reducer';
import { oidcReducer as oidc } from './oidc/redux';
import paymentForm from './paymentForm/reducer';
import projectAddDialog from './projectAddDialog/reducer';
import renameProjectDialog from './renameProjectDialog/reducer';
import renewDialog from './renewDialog/reducer';
import { reducer as route } from './route';
import server from './server/reducer';
import usertaskOperations from './usertask/reducer';
import { reducer as utility } from './utility';

const rootReducer = (history) =>
	combineReducers({
		account,
		api,
		appConfig,
		basket,
		cart,
		cartStack,
		deleteProjectDialog,
		dialogs,
		errors,
		form,
		gtm,
		internalOnly,
		maintenanceMode,
		manageRedirect,
		marketplace,
		oidc,
		paymentForm,
		projectAddDialog,
		renameProjectDialog,
		renewDialog,
		route,
		router: connectRouter(history),
		server,
		usertaskOperations,
		utility,
	});

export default rootReducer;
